import { ThunkAction } from 'redux-thunk';
import { Action } from 'redux';
import { AppointmentsRootState } from '../reducers/appointments';
import { UserState } from '../reducers/authentication';
import AuthenticationRepository, {
  AuthenticationParams,
  RegistrationParams
} from '../../repositories/AuthenticationRepository';
import { Patient, Appointment } from '../../models';
import PatientRepository from '../../repositories/PatientRepository';
import EventBus from '../../services/EventBus';
import { PatientToUpdate } from '../../models/Patient';

export const REQUEST_REGISTER = 'REQUEST_REGISTER';
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const REQUEST_UPDATE = 'REQUEST_UPDATE';
export const UPDATE_PATIENT_SUCCESS = 'UPDATE_PATIENT_SUCCESS';
export const UPDATE_LOCAL_USER_PATIENT = 'UPDATE_LOCAL_USER_PATIENT';
export const ADD_USER_APPOINTMENT = 'ADD_USER_APPOINTMENT';
export const LOGOUT = 'LOGOUT';

export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  AppointmentsRootState,
  unknown,
  Action<string>
>;

type RegisterParameters = {
  name: string;
  firstName: string;
  email: string;
  password: string;
};

function requestRegister(params: AuthenticationParams) {
  return {
    type: REQUEST_REGISTER,
    params
  };
}

function registerSuccess(userData: UserState) {
  return {
    type: REGISTER_SUCCESS,
    user: userData.user,
    accessToken: userData.accessToken,
    receivedAt: Date.now(),
    isRopc: userData.isRopc
  };
}

export function register(params: RegistrationParams): AppThunk {
  return (dispatch) => {
    dispatch(requestRegister(params));
    return AuthenticationRepository.register(params).then((userData: any) => {
      return dispatch(registerSuccess(userData));
    });
  };
}

function requestUpdate(patient: PatientToUpdate) {
  return {
    type: REQUEST_UPDATE,
    patient
  };
}

function UpdateSuccess(patient: Patient) {
  return {
    type: UPDATE_PATIENT_SUCCESS,
    patient: patient
  };
}

export function updateLocalUserPatient(patientAttributesToUpdate: Object) {
  return {
    type: UPDATE_LOCAL_USER_PATIENT,
    patientAttributesToUpdate: patientAttributesToUpdate
  };
}

export function saveUserPatient(patient: PatientToUpdate): AppThunk {
  return (dispatch) => {
    dispatch(requestUpdate(patient));
    return PatientRepository.update(patient).then((updatedPatient) =>
      dispatch(UpdateSuccess(updatedPatient))
    );
  };
}

export function addUserAppointment(appointment: Appointment) {
  return {
    type: ADD_USER_APPOINTMENT,
    appointment
  };
}

type LoginParamaters = {
  email?: string;
  password?: string;
};

function requestLogin(params: LoginParamaters) {
  return {
    type: REQUEST_REGISTER,
    params
  };
}

function loginSuccess(userData: UserState) {
  return {
    type: REGISTER_SUCCESS,
    user: userData.user,
    accessToken: userData.accessToken,
    receivedAt: Date.now(),
    isRopc: userData.isRopc
  };
}

export function login(params: AuthenticationParams): AppThunk {
  return (dispatch) => {
    dispatch(requestLogin(params));
    return AuthenticationRepository.login(params).then((userData) => {
      setTimeout(() => {
        return dispatch(logout);
      }, 3600000); // 1 hour, like token lifetime

      return dispatch(loginSuccess(userData));
    });
  };
}

export function logout() {
  EventBus.success('À bientôt chez Unilabs !');

  return {
    type: LOGOUT
  };
}

export function deleteAccount(password: string, isRopc: boolean): AppThunk {
  return (dispatch) => {
    return AuthenticationRepository.deleteAccount(password).then(() =>
      dispatch(logout())
    );
  };
}
